// The member's own Hub settings.
import { useSuspenseQuery } from '@tanstack/react-query';

import { useCachedQueryData } from '~/lib/app-data/use-cached-query-data';

import { hubMetadataQuery, type HubMetadata } from './hub-metadata-query';

export function useHubMetadata() {
  return useSuspenseQuery(hubMetadataQuery).data;
}

// For code that also renders outside the Hub layout (the color mode a page outside it matches): undefined there.
export function useOptionalHubMetadata() {
  return useCachedQueryData<HubMetadata>(hubMetadataQuery.queryKey);
}
